export default __webpack_public_path__ + "static/media/rightLargeImg.08f58352.jpg";